import { Link } from "react-router-dom";

export default function AffiliateDisclosurePage() {
  return (
    <div className="pb-28 lg:pb-0">
      <div className="max-w-3xl mx-auto px-4 py-12 lg:py-20">
        <nav className="text-sm font-mono text-muted-foreground mb-6">
          <Link to="/" className="hover:text-accent">Home</Link>
          <span className="mx-2">/</span>
          <span>Affiliate Disclosure</span>
        </nav>

        <h1 className="font-heading font-bold text-4xl lg:text-5xl mb-6">Affiliate Disclosure</h1>

        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <p>
            <strong className="text-foreground">HighestEfficiencySolarCell.com</strong> is a participant in the 
            Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means 
            for sites to earn advertising fees by advertising and linking to Amazon.com.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground pt-4">What This Means for You</h2>
          <p>
            When you click on product links on this site and make a purchase on Amazon, we may earn a small 
            commission. This commission comes from Amazon — not from you. Your purchase price is exactly the 
            same whether you use our affiliate link or go to Amazon directly.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground pt-4">How We Use Affiliate Revenue</h2>
          <p>
            Affiliate commissions help us cover the costs of running this website, including hosting, research, 
            and content creation. This support allows us to continue providing free, helpful solar panel 
            buying guides and comparison tools.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground pt-4">Our Editorial Independence</h2>
          <p>
            Our product recommendations are based on publicly available specifications, user feedback, and 
            technical analysis. We do not accept payment from manufacturers to feature specific products. 
            If a product has significant drawbacks, we will note them regardless of our affiliate relationship.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground pt-4">Questions?</h2>
          <p>
            If you have questions about our affiliate relationships, please{" "}
            <Link to="/contact" className="text-accent hover:underline">contact us</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}